module.exports = __webpack_public_path__ + "media/images/follow-up-2a86bfd9e6baedab280ecbe4d954c758.svg";